import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function StripeRedirectHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    // Log the full URL
    const fullUrl = window.location.href;
    console.log("Full URL:", fullUrl);
  
    // Get the path part of the URL
    const path = window.location.pathname;
    console.log("Path part of URL:", path);
  
    if (path.startsWith("/forgotPassword/")) {
      const token = path.replace("/forgotPassword/", ""); // Extract the token
      console.log("Extracted token:", token);
  
      if (token) {
        navigate(`/changepassword/${token}`, { replace: true });
      }
    }
  }, [navigate]);
  

  return null; // Component doesn't render anything visually
}

export default StripeRedirectHandler;
